var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M165.5 97.233L99.098 39 34.5 97.514l5.661 6.214 7.969-7.218V161h103.79V96.504l8.02 7.033 5.56-6.304zm-75.476 53.68v-31.208h20.006v31.208H90.024zm53.479 1.694h-25.054v-41.298H81.605v41.298H56.549V88.883L99.19 50.258l44.313 38.864v63.485z","fill":"currentColor","data-color":"1"})));
}

Home.defaultProps = {"preserveAspectRatio":"xMidYMid meet","id":"comp-k95e8fcfsvgcontent","data-bbox":"34.5 39 131 122","viewBox":"34.5 39 131 122","data-type":"color","role":"img"};

module.exports = Home;

Home.default = Home;
